export var borderRadiusThemes = {soft:'c5-30-0_12l8vgd4',sharp:'c5-30-0_12l8vgd5',round:'c5-30-0_12l8vgd6'};